import React, { Component, useState } from 'react';
import { withStyles } from '@material-ui/core/styles';
import { withTranslation } from 'react-i18next'
import LoginEmailView from './LoginEmailView';
import Loading from '../../components/Loading';
import ModalAlert from '../../components/ModalAlert';
import crmServices from '../../wsclient/'
import t from '../../utils/translateUtil';
import { startCountDown } from "../../utils/util";
import {getAppCfg,getBrowser, getRejectTriggerContact, getSupportOrder, getSupportOrderLocation, setContacts, setSupportOrder, setSupportOrderContact} from '../../utils/common'
import { connection, domainName, portal_config } from '../../../portal.config';
import { paths } from '../../../portal.router.config';
import ModalConfirm from '../../components/ModalConfirm';
import { dataUtil } from '../../wsclient/crmservices/dataUtil';
import { Grid } from '@material-ui/core';
import { LinkCTA, LinkInLine, LinkRouter } from '../../components/Link';
import OtpView from '../login/OtpView';
import crmservices from '../../wsclient/';
import { order_key, setOrderCache } from '../../utils/order_cache';
const styles = theme => ({

});
function LoginEmail(props){
    

    const [showLoading, onShowLoading] = useState(false);
    const [login_info, setLoginInfo] = useState({});
    const [active, setActive] = useState('main');
    const [auth_otp, setAuthOtp] = useState(null);
    const [obfuscated_value, setObfuscatedValue] = useState(null);
    const [confirm, setConfirm] = useState({});
    const [error, setError] = useState({
        showAlert: false,
        title: '',
        message: '',
        status: '',
    })
    let app_config = getAppCfg();
    const auth_support = app_config && app_config.auth_support ? app_config.auth_support: {facebook:false, google:false};

    const showAlert = (status, message, title, children) => {
        onShowLoading(false);
        setError({
            showAlert: true,
            title: title,
            message: message,
            status: status,
            children: children,
            });
    }
    const onCloseAlert = () => {
        onShowLoading(false);
        setError({
            showAlert: false,
            title: '',
            message: '',
            status: '',
            });
    }

    const  onLogin = async (values) => {
        onShowLoading(true);
        setLoginInfo(values);

        const config = getAppCfg()
        let isEmailOtp = config && config.auth_support && config.auth_support.email_otp;
        const application_id = config && config.id ? config.id : null;
            try {
                var startSession = !isEmailOtp ? true : false
                var result = null;
                if (isEmailOtp){
                    //result = await crmServices.contacts.sendCredentialsOTP({send_method: 'EMAIL', name: 'EMAIL', value: values.username});
                    result = await crmServices.contacts.authenticate({provider: 'EMAIL', username: values.username, application_id: application_id}, false);
                }
                else{
                    result = await crmServices.contacts.authenticateEmail({ ...values },startSession);
                }
                //console.log('onLogin Email result = ', result)
                if (result.code === 'OK') {
                    if (isEmailOtp) {
                        setActive('verify');
                        setAuthOtp(result.data.auth_otp);
                        setObfuscatedValue(result.data.obfuscated_value);
                    }
                    else{
                        //crmServices.contacts.addApplicationUsage(config.id,getBrowser().toUpperCase());
                        onShowLoading(false);
                        setActive('home');
                        if(!getSupportOrderLocation()&&!getRejectTriggerContact()){
                            
                            var ordering_countries = []
                            if(config.features && config.features.ordering &&config.features.ordering_details&&config.features.ordering_details.ordering_countries){
                                ordering_countries = config.features.ordering_details.ordering_countries
                            }
                            var isAllowOrder = await dataUtil.checkAllowOrderByContact(ordering_countries);
                            if(isAllowOrder){
                                setSupportOrderContact(true)
                            }
                        }
                        await checkTriggerFavouriteStore(config);
                        //props.history.push('/home');
                    }
                } else if(result.code=='EMAIL_NOT_VERIFIED'){
                    showAlert("ERROR", t('EMAIL_NOT_VERIFIED'),  t('ERROR'), true);
                } else {
                    showAlert("ERROR", t('INVALID_EMAIL_LOGIN'),  t('ERROR'));
                }
            } catch (error) {
                showAlert("ERROR", t('EXCEPTION_PROCESS'));
            }
            onShowLoading(false);
    }
    const checkTriggerFavouriteStore = async (appConfig) => {

        // console.log('checkTriggerFavouriteStore router=',router)
        if (!portal_config[domainName].triggerCheckFavouriteStore) {
            // console.log('checkTriggerFavouriteStore route2r=',router)
            onShowLoading(false);
            props.history.push(paths.home);
        } else {
            try {
                var result = await crmservices.contacts.getContactPreferences();
                if (result.code == "OK") {
                    var favouriteStores = result.data && result.data.organisations ? result.data.organisations : [];
                    setOrderCache(order_key.order_favourite_shop, favouriteStores);
                    if (favouriteStores.length == 0) {
                        var result = await crmservices.contacts.getContact();
                        if (result.code === "OK") {
                            setContacts(result.data);
                        }
                        onShowLoading(false);
                        props.history.push(paths.favourite_store);
                    } else {
                        onShowLoading(false);
                        props.history.push(paths.home);
                    }
                } else {
                    onShowLoading(false);
                    props.history.push(paths.home);
                }
            } catch (error) {
                console.log("get preferences exception:", error);
                onShowLoading(false);
                props.history.push(paths.home);
            }
        }
    }
    const onVerify = async (values) => {
        onShowLoading(true);
        try {
            var config = getAppCfg();
            var verifyOtp = await crmServices.contacts.validateOTP({ phone: null, auth_otp: auth_otp, otp: values.otp_code });
            if (verifyOtp.code === "OK") {
                //crmServices.contacts.addApplicationUsage(config.id,getBrowser().toUpperCase());
                onShowLoading(false);
                if(!getSupportOrderLocation()&&!getRejectTriggerContact()){
                    var ordering_countries = []
                    if(config.features && config.features.ordering&&config.features.ordering_details&&config.features.ordering_details.ordering_countries){
                        ordering_countries = config.features.ordering_details.ordering_countries
                    }
                    var isAllowOrder = await dataUtil.checkAllowOrderByContact(ordering_countries);
                    if(isAllowOrder){
                        setSupportOrderContact(true)
                    }
                }
                await checkTriggerFavouriteStore(config);
               // props.history.push('/home');
            } else {
                showAlert("ERROR", t('INVALID_OTP'), t('OTP'));
            }
            onShowLoading(false);
        } catch (error) {
            console.log("error:", error);
            showAlert("ERROR", t('EXCEPTION_PROCESS'), t('OTP'));
        }
    }
    const onResendCode = async() => {
        onShowLoading(true);
        try {
            var startSession = false;

            const config = getAppCfg()
            let isEmailOtp = config && config.auth_support && config.auth_support.email_otp;
            const application_id = config && config.id ? config.id : null;
            var result = null;
            if (isEmailOtp){
                //result = await crmServices.contacts.sendCredentialsOTP({send_method: 'EMAIL', name: 'EMAIL', value: values.username});
                result = await crmServices.contacts.authenticate({provider: 'EMAIL', username: login_info.username, application_id: application_id}, false);
            }
            else{
                result = await crmServices.contacts.authenticateEmail({ ...login_info },startSession);
            }
             
            //console.log("AAAAAAA result:",result);
            if (result.code === 'OK') {
                if (result.data && result.data.auth_otp) {
                    setAuthOtp(result.data.auth_otp);
                }
                showAlert('SUCCESS', isEmailOtp ? t('OTP_RESEND_EMAIL_SUCCESS') : t('OTP_RESEND_SUCCESS'), t('OTP'))
               // this.beginCountDown();
            } else {
                showAlert('ERROR', t('EXCEPTION_PROCESS'), t('OTP'))
            }
        } catch (error) {
            console.log("onResendCode error:",error);
            showAlert('ERROR', t('EXCEPTION_PROCESS'), t('OTP'))
        }
        onShowLoading(false);
    }
    const onRegister = async () => {
        const appConfig = getAppCfg()
        var isEmailPassword =
        appConfig &&
        appConfig.auth_support &&
        appConfig.auth_support.email_password;
        if(domainName == 'airlink')
            props.history.push(paths.register_existing);
        if (document._portalConfig.isCredentials)
            showConfirm(true, t('exits_rewards_participant'));
        else
            props.history.push(paths.register);
    }
    const onYesExistRewards = () => {
        props.history.push(paths.identify);
        showConfirm(false)
    }
    const onNoExistRewards = () => {
        props.history.push(paths.register);
        showConfirm(false)
    }
    const showConfirm = (status, message) => {
        onShowLoading(false);
        setConfirm({
            show: status,
            content: message ? message : null});
    }
    const onResendVerification = async () => {
        //console.log(' login_info===',this.state.login_info)
        if (!login_info&&!login_info.username){
            return;
        }
        onShowLoading(true);
        try {
            var result = await crmServices.contacts.sendEmailVerification(login_info.username);
            //console.log("AAAAAAA result:",result);
            if (result.code === 'OK') {
                showAlert('SUCCESS', t('RESEND_EMAIL_SUCCESS'), t('OTP'))
            } else if(result.code=='TOO_MANY_REQUESTS'){
                showAlert(t('ERROR'), t('TOO_MANY_REQUESTS'));
            } else if(result.code=='TOO_MANY_RECIPIENTS_EXCEPTION'){
                showAlert(t('ERROR'), t('TOO_MANY_RECIPIENTS_EXCEPTION'));
            } else {
                showAlert('ERROR', t('EXCEPTION_PROCESS'), t('OTP'))
            }
        } catch (error) {
            showAlert('ERROR', t('EXCEPTION_PROCESS'), t('OTP'))
        }
        onShowLoading(false);
    }

    return (
        <div>
         {active==='main'&&<LoginEmailView
            onLogin={onLogin}
            showAlert = {showAlert}
            onShowLoading = {onShowLoading}
            auth_support = {auth_support}
            onRegister = {onRegister}
            />}
        {active === 'verify'&& <OtpView
            onLogin={onVerify}
            onResend={onResendCode}
            obfuscatedValue={obfuscated_value}
        />}
            <Loading showLoading={showLoading} />
            {confirm && <ModalConfirm
                open={confirm.show}
                onClose={onNoExistRewards}
                message={confirm.content}
                confirm={t('yes')}
                buttonLabel={t('no')}
                onAction={onYesExistRewards}
            />}
            <ModalAlert
                open={error.showAlert}
                onClose={onCloseAlert}
                hideHeader={true}
                message={error.message}
                error={error.status}
                title={error.title}
                children={error.children&&<Grid xs={12} item container justify='center' style={{marginTop:16}}>
                    <LinkCTA color='primary' underline
                        onClick={onResendVerification}>
                        {t('resend_verification_email')}
                    </LinkCTA>
                </Grid>
                }
            />
        </div>
    );
}


export default withStyles(styles)(withTranslation()(LoginEmail));